import React, {useEffect, useRef, useState} from 'react'
import { Modal, Logo } from '../../components';
import { useHistory } from 'react-router';

import { FormattedMessage } from '../../util/reactIntl';

import css from './TransactionPanel.css';

export default function TransactionAlert(props) {

    const [showModal, setShowModal] =  useState(false);
    const targettedRoute = useRef("");
    const [showConfirmationButton, setShowConfirmationButton] = useState(false)
    const history = useHistory();

    useEffect(()=>{
        setShowConfirmationButton(props.showConfirmationButton)

        console.log("show confirmation button", showConfirmationButton)

        const block = history.block((location, action) => {
          if (!props.conformationChecker() ) {
            if(!showConfirmationButton) return true
          targettedRoute.current = location
          setShowModal(true)
          
          return false
        };
         return true
        }); 
       
      
        return () => {
          console.log("show Confirmation in return", showConfirmationButton)
          
            block()
            }
          
  

    },[showConfirmationButton])
  return (
      
      <Modal
      id="AuthenticationPage.tos"
      isOpen={showModal}
      onClose={()=>setShowModal(false)}
      onManageDisableScrolling={() => {}}
      usePortal={false}
      > <Logo
      format="desktop"
      style={{ marginBottom: '7px' }}
      />
<div className={css.textWrapper}>
   <FormattedMessage id="BlockRedirect.confirmation" /> 
</div>

<div className="buttonbox">
  <button className={css.submitButtonEmpty} type="button" onClick={()=>{history.block(()=>{})
  history.push(targettedRoute.current)}}>
    <FormattedMessage id="BlockRedirect.yes" />
  </button>

  <button className={css.submitButtonYes} type="button" onClick={()=>setShowModal(false)}>
    <FormattedMessage id="BlockRedirect.no" />
  </button>
</div></Modal>
  )
}
